<script setup>
    import { useProjectListStore } from '@/lib/stores/project-list-store';
    import { FilterType } from '@/lib/constants/constants';

    const store = useProjectListStore();

    const props = defineProps({
        tagsTitle: String,
        tagsFilterResult: Array
    });
</script>

<template>
    <div class="col-12 col-md-12 col-xl-8">
        <div class="tag-filters">
            <h2 class="lead-classic-large">{{ props.tagsTitle }}</h2>

            <div class="container">
                <div class="row">
                    <div
                        class="col-6 col-md-3 input-checkbox-filter"
                        :class="{ active: store.isActiveFilter(tag.id) }"
                        v-for="tag in props.tagsFilterResult"
                        :key="tag.name"
                        @click.prevent="store.toggleFilter(tag.id, tag.name, FilterType.TAG)"
                    >
                        <input :id="tag.id" type="checkbox" name="consent" required />
                        <label :for="tag.id">
                            {{ tag.name }}
                            <sub>{{ tag.articleIds.length }}</sub>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
